import { render } from "./mention_link.vue?vue&type=template&id=6e9ac100"
import script from "./mention_link.js?vue&type=script&lang=js&external"
export * from "./mention_link.js?vue&type=script&lang=js&external"

import "./mention_link.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__